

<template>
    <v-container>
        <v-card class="modal">
            
           

        <v-card class="modal-backdrop" style="" ref="modal" id="forgotPwdModal" data-keyboard="false" data-backdrop="static">
            <div class="otpModal otpResponsive">

            <section class = "modal-body">

                <slot name="body">
                    <v-flex style="text-align: center;font-size: 20px; border-bottom: 1px solid darkgrey;padding-bottom: 2%;">
                           <b><label style="font-family: Arial;" > Forgot Password</label></b> 
                           <a @click="close()"><span style="float: right; color: red;">X</span></a>
                    </v-flex>

                    <div style="margin-top: 1rem; margin-bottom: 1rem;">
                    <label for="verifyUserName">
                        <h3>Username</h3>
                    </label>
                    <p style="margin-bottom: 2rem; color: darkgrey"> You will receive a 6 digit code to the registered mail/ mobile number for verification</p>
                    
                    <v-text-field :autocomplete="'off'" class="UNStyle" transition="slide-x-transition" id="" solo v-model="verifyUserName" name="verifyUserName" label="Enter Username" maxlength="5" type="tel" inputmode="numeric" v-on:keypress="isNumber($event)" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);this.value = this.value.replace(/[^0-9]/gi, '');"></v-text-field>
                    <div style="color:red;text-align: left;padding-bottom: 2px;" v-if="verifyUserNameErrMsg.length > 0">{{verifyUserNameErrMsg}}</div> 
                </div>

                    <v-flex class="modal-footer">
                        <v-flex class="text-align-center padding-bottom-5" style="display: -webkit-inline-box; -webkit-box-pack: center;">
                                <v-btn class="text-align-center padding-bottom-5 text-none" color="primary-btn" v-on:click="PreLoader=true;continueToOtpPage()" dark block >Continue</v-btn>
                            </v-flex>
                           
                    </v-flex>

                </slot>
            </section>
            </div>
        </v-card>
        </v-card>

        <!--Preloader starts-->
   <div class="pre-loader" v-show="PreLoader==true" v-hide="PreLoader == false">
    
    <img :src="preLoaderImg">
  
  </div>
  
  <!--Preloader ends-->
    </v-container>
</template>

<script type="javascript">
import router from '@/router';
import { db, externalURL, sunidhiPlugin } from '@/sunidhiapp';
import { reactive } from 'vue';
import '@/sunidhiapp';
import $ from 'jquery';
import loader from '@/assets/images/Preloader.gif';
import { getSessionId } from '@/services/sessionservice';
 export default {
    name: 'ForgotPassword',
    data: function(){
        return{
            verifyUserName: "",
            PreLoader: false,
            verifyUserNameErrMsg: "",
            preLoaderImg: loader,

        };
    },
    mounted: async function(){
        const sunidhi = reactive(sunidhiPlugin);
        self.PreLoader = false;
        sunidhi.logoutBtnDisp = 'false';
    },
    methods: {
        async close(){
            const sunidhi = reactive(sunidhiPlugin);
            sunidhi.logoutBtnDisp = 'false';
            router.push({ name: 'LoginPage'});
        },

        async continueToOtpPage(){
            var self = this;
            self.PreLoader = true;
            var vaerror = 0;
            
            if(self.verifyUserName.length <=0){
                self.verifyUserNameErrMsg =" Enter Username"
                vaerror = 1;
            }

            if(vaerror == 1){
                setTimeout(() => {
                    self.PreLoader= false
                }, 500);

                return;
            } else {
                var object = new Object();
                object.verifyUserName = self.verifyUserName;
                var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
                    if (genzdata != null && genzdata.length > 0) {
                        await db.TbGenz.update(genzdata[0].PkId, {LoginUserID: object.verifyUserName});
                    } else {
                        await db.TbGenz.put({ UserId: 1,LoginUserID: object.verifyUserName});
                        genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
                    }

                await self.ValidateForgotPWADSALoginId(object.verifyUserName);
               
            }
        },
    async ValidateForgotPWADSALoginId (UserID){
    // const sunidhi = reactive(sunidhiPlugin);
    var self = this;
    var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
    console.log("sinidhiiiiiii", this.$sunidhi);
    var copySunidhi = this.$sunidhi;
    var ForgotPwdDSAUserIDDecrypted =""
    $.ajax({
        url: externalURL + "ValidatePWADSALoginId/",
        type: "POST",
        headers:{
            "PWADSALoginId": UserID,
            "PwaUserType": this.$sunidhi.PwaUserType, // DSA
            // "PWAUserSessionId": genzdata[0].PWAUserSessionId
            "PWAUserSessionId": getSessionId()
        },
        responseType: "application/text",
        success:async function(data){

console.log("ValidatePWADSALoginId respons ", data)

            if(data){
                if(data.DSAAuthenticationStatus !=="01"){
                    if(data.PWAUserAuthenticationStatus){
                    switch(data.PWAUserAuthenticationStatus){
                        case "76": //success
                       var loginType = data.PasswordUpdateType ;
                       if(data.PWAUserUserId != null){
                        ForgotPwdDSAUserIDDecrypted = await copySunidhi.decryptValue(data.PWAUserUserId, copySunidhi.keyValue);
                        console.log("ForgotPwdDSAUserIDDecrypted:::", ForgotPwdDSAUserIDDecrypted)
                        ForgotPwdDSAUserIDDecrypted.trimEnd();
                       }
                        var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
                        if (genzdata != null && genzdata.length > 0) {
                            await db.TbGenz.update(genzdata[0].PkId, {loginType :loginType,DSAUserId: ForgotPwdDSAUserIDDecrypted});
                        } else {
                            await db.TbGenz.put({ UserId: 1,loginType :loginType, DSAUserId: ForgotPwdDSAUserIDDecrypted});
                            genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
                        }
                        setTimeout(()=>{
                            self.PreLoader = false;
                          },500);
                            router.push({ name : 'otpPage'});
                            setTimeout(()=>{
                                self.PreLoader = false;
                              },500);
                            break;
                        case "101":
                            self.verifyUserNameErrMsg = "Please enter a valid Username";
                            setTimeout(() =>{
                                self.PreLoader = false;
                            },500)
                            break;
                    }


                }

                }else{
                    alert(data.message)
                    setTimeout(()=>{
                                self.PreLoader = false;
                              },500);
                }

               
            // }
            }
        }, error: async function(){
            setTimeout(() =>{
                self.PreLoader = false;
            },500)
            alert("Error in Changing the Password");
        }
        
    });
    
},
        isNumber: function(evt) {

                        
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 43) 
            {
            evt.preventDefault();
            } 
            else 
            {
            return true;
            }
            },
    }
}

</script>

<style lang="css" scoped>



.modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3) !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px -1px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
	width:50%;
  }
  .otpResponsive {
    background: #FFFFFF;
    box-shadow: 2px 2px -1px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
	width:50%;
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
    display: flex;
  }

  .modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
  }

  .modal-footer {
    /* border-top: 1px solid #eeeeee; */
    flex-direction: column;
    justify-content: flex-end;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }

  .float-child {
    width: 13%;
    float: left;
    padding: 0px;
    margin-right: 8px;
  }


  @media screen and (max-width:280px) {
    .otpResponsive{
       width: 90% !important;
    }
  }

  @media screen and (max-width:300px) {
    .otpResponsive{
       width: 90% !important;
    }
  }
  @media screen and (max-width:475px) {
    .otpResponsive{
       width: 90% !important;
    }
  }

  
  @media screen and (max-width:600px) {
    .otpResponsive{
       width: 90% !important;
    }
  }

  @media screen and (min-width:650px) {
    .otpResponsive{
       width: 50% !important;
    }
  }

  

@media screen and (min-width:790px) {
    .otpResponsive{
       width: 50% !important;
    }
}

@media screen and (min-width: 960px){
    .otpResponsive{
       width: 50% !important;
    }
}

@media screen and (min-width:992px) {

    .otpResponsive{
       width: 50% !important;
    }
 
} 


@media screen and (min-width:1024px) {

    .otpResponsive{
   width: 50% !important;
}
} 

@media screen and (min-width:1280px) {

    .otpResponsive{
       width: 50% !important;
    }
  } 

@media screen and (min-width:1536px) {

    .otpResponsive{
       width: 50% !important;
    }
  } 

  

</style>